import { IColumn } from '@features/General'
import PencilFillIcon from 'remixicon-react/PencilFillIcon'
import { CompanySubscriptionStatusColors } from '../index'

export const listColumns = (onEdit, i18n, appDirection, isCompany): IColumn[] => [
    {
        title: i18n?.General?.Company,
        key: 'company',
        type: 'nested',
        fields: ['name'],
        allowHide: true
    },
    {
        title: i18n?.TradeHub?.Plan_Name || 'Plan Name',
        key: 'subscription',
        type: 'nested',
        fields: ['name'],
        allowHide: true,
        sorter: true
    },
    {
        title: i18n?.TradeHub?.Max_Subscribers || 'Max Subscribers',
        key: 'maxSubscribers',
        allowHide: true,
        sorter: true,
        hide: !isCompany
    },
    {
        title: i18n?.TradeHub?.Max_Users || 'Max Users',
        key: 'maxUsers',
        allowHide: true,
        sorter: true,
        hide: isCompany
    },
    {
        title: i18n?.TradeHub?.Points || 'Points',
        key: 'points',
        allowHide: true,
        sorter: true,
        hide: !isCompany
    },
    {
        title: i18n?.TradeHub?.Remaining_Points || 'Remaining Points',
        key: 'remainingPoints',
        allowHide: true,
        sorter: true,
        hide: !isCompany
    },
    {
        title: i18n?.General?.Date,
        key: 'expiryDate',
        type: 'dateTime',
        format: 'DD.MM.YYYY',
        allowHide: true,
        sorter: true
    },
    {
        title: i18n?.General?.Created_by || 'Created by',
        key: 'users',
        type: 'nested',
        fields: ['firstname', 'lastname'],
        hide: !isCompany
    },
    {
        title: i18n?.General?.Status,
        dataIndex: 'status',
        key: 'subscriptionStatus',
        type: 'badge',
        bg: value => CompanySubscriptionStatusColors[value],
        align: appDirection === 'rtl' ? 'right' : 'left'
    },
    {
        key: 'actions',
        type: 'actions',
        actions: () => [
            {
                title: i18n?.General?.Edit,
                icon: PencilFillIcon,
                key: 'edit',
                abilityAction: 'EditSubscription',
                abilityService: 'Subscription',
                onClick: record => onEdit(record._id)
            }
        ]
    }
]
